import { useMutation, useQueryClient } from "@tanstack/react-query";
import klydoApiClient from "../../../api/klydo";

const useCreateKlydoLabelMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: { text: string }) => {
      return await klydoApiClient.createKlydoLabel(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["klydo-labels"] });
    },
    onError: (error) => {
      console.error("Failed to create klydo label:", error);
    },
  });
};

export default useCreateKlydoLabelMutation;
